import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { Home } from "@/pages/Home";

// Home stays in the main bundle (it's the landing page — fastest first paint).
// Every other route is code-split so it only downloads when visited, keeping
// the initial JS small. Pages use named exports, hence the `.then` remap.
const Services = lazy(() => import("@/pages/Services").then((m) => ({ default: m.Services })));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail").then((m) => ({ default: m.ServiceDetail })));
const About = lazy(() => import("@/pages/About").then((m) => ({ default: m.About })));
const Capabilities = lazy(() => import("@/pages/Capabilities").then((m) => ({ default: m.Capabilities })));
const ServiceAreas = lazy(() => import("@/pages/ServiceAreas").then((m) => ({ default: m.ServiceAreas })));
const Location = lazy(() => import("@/pages/Location").then((m) => ({ default: m.Location })));
const SafetyCompliance = lazy(() => import("@/pages/SafetyCompliance").then((m) => ({ default: m.SafetyCompliance })));
const Faqs = lazy(() => import("@/pages/Faqs").then((m) => ({ default: m.Faqs })));
const Contact = lazy(() => import("@/pages/Contact").then((m) => ({ default: m.Contact })));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy").then((m) => ({ default: m.PrivacyPolicy })));
const Terms = lazy(() => import("@/pages/Terms").then((m) => ({ default: m.Terms })));
const NotFound = lazy(() => import("@/pages/NotFound").then((m) => ({ default: m.NotFound })));

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: "60vh" }} aria-hidden="true" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:suburb" element={<Location />} />
          <Route path="/safety-compliance" element={<SafetyCompliance />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
